import {
    Service
  } from '../service.js'
  import {
    env
  } from '../env.js'
  
  export class PermissaoService extends Service {
    constructor(controleDeInstancia) {
      super(controleDeInstancia);
      this.url = env.url + "permissao";
      
      this.controladoresDeInstancia = {
        verificarPermissaoPorId: new AbortController(),
        verificarPermissao: new AbortController(),
        atualizarPermissaoPorId: new AbortController(),
        atualizarPermissao: new AbortController()
      }
    }

    /**
     * Faz override do post padrão para não remover id do request;
     * @override
     */
    async post(url, dto, controlador) {
      this.ultimosControladores.post = this.selecionarControlador(controlador);
  
      const init = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.adquirirToken()
        },
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify(dto),
        signal: this.ultimosControladores.post.signal
      }
  
      return fetch(url, init).then(response => response)
    }
  
    async verificarPermissaoPorId(id, controlador) {
      this.controladoresDeInstancia.verificarPermissaoPorId = this.selecionarControlador(controlador);
      return super.get(`${this.url}/verificarpermissao/${id}`, this.controladoresDeInstancia.verificarPermissaoPorId);
    }

    async atualizarPermissaoPorId(id, controlador) {
      this.controladoresDeInstancia.atualizarPermissaoPorId = this.selecionarControlador(controlador);
      return super.get(`${this.url}/atualizarPermissao/${id}`, this.controladoresDeInstancia.atualizarPermissaoPorId);
    }

    async verificarPermissao(tarefa, controlador) {
      const endpoint = `${this.url}/verificarpermissao`
      this.controladoresDeInstancia.verificarPermissao = this.selecionarControlador(controlador);
      const response = await super.post(endpoint, tarefa, this.controladoresDeInstancia.verificarPermissao);
      if (response.ok) {
          return response.json();
      } else {
          const toastUtils = await this.adquirirToastUtils();
          toastUtils.dangerToast("Não foi possível verificar permissões do(s) usuário(s).");
          throw new Error('HTTP ' + response.status);
      }
    }

    async atualizarPermissao(tarefa, controlador) {
      const endpoint = `${this.url}/atualizarPermissao`
      this.controladoresDeInstancia.atualizarPermissao = this.selecionarControlador(controlador);
      const response = await super.post(endpoint, tarefa, this.controladoresDeInstancia.atualizarPermissao);
      if (response.ok) {
          return response;
      } else {
          const toastUtils = await this.adquirirToastUtils();
          toastUtils.dangerToast("Não foi possível atualizar permissões do(s) usuário(s).");
          throw new Error('HTTP ' + response.status);
      }
    }

    async verificarPermissaoEdicaoAvulsa(objetoDeEdicao, controlador) {
      const endpoint = `${this.url}/verificarpermissao/avulsa`
      this.controladoresDeInstancia.verificarPermissao = this.selecionarControlador(controlador);
      const response = await this.post(endpoint, objetoDeEdicao, this.controladoresDeInstancia.verificarPermissao);
      if (response.ok) {
          return response.json();
      } else {
          const toastUtils = await this.adquirirToastUtils();
          toastUtils.dangerToast("Não foi possível verificar permissões do(s) usuário(s).");
          throw new Error('HTTP ' + response.status);
      }
    }

    async atualizarPermissaoEdicaoAvulsa(objetoDeEdicao, controlador) {
      const endpoint = `${this.url}/atualizarPermissao/avulsa`
      this.controladoresDeInstancia.atualizarPermissao = this.selecionarControlador(controlador);
      const response = await this.post(endpoint, objetoDeEdicao, this.controladoresDeInstancia.atualizarPermissao);
      if (response.ok) {
          return response;
      } else {
          const toastUtils = await this.adquirirToastUtils();
          toastUtils.dangerToast("Não foi possível atualizar permissões do(s) usuário(s).");
          throw new Error('HTTP ' + response.status);
      }
    }
  }
  
  export const permissaoService = new PermissaoService()
  